export const SPECIALTY_FETCH_ALL_INIT = 'SPECIALTY_FETCH_ALL_INIT';
export const SPECIALTY_FETCH_ALL = 'SPECIALTY_FETCH_ALL';
